<template>
	<div>
		<div class="firstSection">
			<header id="masthead" class="allP responsive">
			<div class="homeImage show-mobile" :style="{'background-image': homeImageUrl}"></div>
				<div
						class="wp1200 topBar"
						v-bind:class="{ ' ': !showFixed, 'show-fixed': showFixed }"
				>
					<a class="logo" href>{{ $t("home.header_title") }}</a>
					<span
							class="icon menu-button show"
							v-bind:class="{
							' warpit_icon_hamburger': closeNavigation,
							' warpit_icon_MINUS': !closeNavigation,
						}"
							v-on:click="menuButtonClicked()"
					>
						<span class="notification"></span>
					</span>
					<router-link :to="{ name: 'surveys' }">
						<a class="surveyIcon">
							<span class="icon warpit_icon_survey">
								<span class="notification"></span>
							</span>
						</a>
					</router-link>
					<Navigation
							v-bind:active_el="active_el"
							v-bind:closeNavigation="closeNavigation"
					></Navigation>
				</div>
				<div class="wp1200 lightBubbleWrapperResponsive">
					<div class="lightBubble">
						<div class="bubbleImage"></div>
						<p class="typewriter">
							<vue-typewriter v-bind:text="setTyperTextWelcome" v-if="numberOfValidTransactions === 0" />
							<vue-typewriter v-bind:text="setTyperTextMore" v-else-if="numberOfValidTransactions > 0 && getProjectCount > 0" />
							<vue-typewriter v-bind:text="setTyperTextWait" v-else />
						</p>
					</div>
				</div>
				<div class="blueTriangleHeadSpecial"></div>
				<div class="containerHeadSpecial"></div>
			</header>

			<div class="homeImage show-desktop" :style="{'background-image': homeImageUrl}"></div>

			<div class="navigation wp710">
				<ul>
					<li>
						<router-link
							:to="{ name: 'surveys' }"
							class="hoverEffect"
							ref="joinButton4"
							v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton4')"
							v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton4')"
						>
							<span
								class="effect"
								ref="effectButton4"
								v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"
							></span>
							<h3 class="navTitle">{{ $t("dashboard.surveys_for_you") }}</h3>
							<span class="flex">
								<span class="icon warpit_icon_survey"></span>
								<span class="number">{{ getProjectCount }}</span>
							</span>
						</router-link>
					</li>
					<li>
						<router-link :to="{ name: 'awards' }" class="hoverEffect">
							<span class="effect"></span>
							<span class="navTitle">{{ $t("dashboard.points1") }}</span>
							<span class="flex">
								<span class="number">{{ formatNumber(getAvailablePoints(points.transactions)) }}</span>
								<span class="icon warpit_icon_loyalty-point"></span>
							</span>
						</router-link>
					</li>
					<li v-if="isPahse2Enable === true">
						<a href="#" class="hoverEffect">
							<span class="effect"></span>
							<h3 class="navTitle">nova sporočila</h3>
							<div class="flex">
								<span class="warpit_icon_message icon">
									<span class="notification"></span>
								</span>
								<span class="number">3</span>
							</div>
						</a>
					</li>
					<li v-if="isPahse2Enable === true">
						<a href="#" class="hoverEffect">
							<span class="effect"></span>
							<h3 class="navTitle">vaš profil</h3>
							<div class="flex">
								<span class="warpit_icon_user icon"></span>
								<span class="number">37%</span>
							</div>
						</a>
					</li>
				</ul>
				<div class="scrollDown flex" v-if="scrollButtonEnable === true">
					<span class="circle flex">
						<span class="icon warpit_icon_down" @click="goto('div1')"></span>
					</span>
					<span class="txt" style="color:#fff;">{{ getProjectCount }} {{ $t("dashboard.news") }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Navigation from "../Navigation.vue";
import {formatNumber, getAvailablePoints} from '@/helpers.js';
import VueTypewriter from "@/components/VueTypewriter";
import { formUtilsMouseHoverEffect} from '@/utils/form_utils.js';

export default {
	props: ["scrollButtonEnable"],

	data() {
		return {
			showFixed: false,
			closeNavigation: true,
			active_el: 1,
			topX: 1,
			leftX: 1,
			isPahse2Enable: false,
			notCompleted: true,
		};
	},
	update(){
		this.points();
	},
	computed: {
		homeImageUrl() {
			let randomImageIndex = Math.floor((Math.random() * 5) + 1); /** Random between 1-5 **/
			let urlPath = null;

			/** If image can't be found, return null and style will not be applied **/
			try {
				urlPath = require(`@/assets/images/randomImages/image${randomImageIndex}.png`);
			} catch (e) {
				console.log("Image probably does not exist");
			}

			return `url('${urlPath}')`;
		},
		user() {
			return this.$store.getters["user/user"];
		},
		projects() {
			return this.$store.getters["user/projects"];
		},
		invites() {
			return this.$store.getters["user/invites"];
		},
		info() {
			return this.$store.getters["user/info"];
		},
		points() {
			return  this.$store.getters["user/points"];
		},
		setTyperTextWelcome() {
			const base = `Dobrodošli, ${this.user.name}!`;
			return `${base} Z včlanitvijo ste prejeli 100 točk! Izpolnite kakšno anketo, da bi jih dobili še več.`;
		},
		setTyperTextMore() {
			const base = `Dobrodošli, ${this.user.name}!`;
			return `${base} S svojo aktivnostjo v Episcenter klubu ste zbrali ${formatNumber(getAvailablePoints(this.points.transactions))} točk! Izpolnite kakšno anketo, da bi jih dobili še več.`;
		},
		setTyperTextWait() {
			const base = `Dobrodošli, ${this.user.name}!`;
			return `${base} S svojo aktivnostjo v Episcenter klubu ste zbrali ${formatNumber(getAvailablePoints(this.points.transactions))} točk! Za dodatne točke, počakajte še na kakšno tematsko anketo.`;
		},
		getProjectCount() {
			return this.projects.filter(project =>
				project.qStatus != "1" &&
				(!project.custom_attributes || !project.custom_attributes.some(attr => attr.value === "usepoints"))
			).length;
		},
		numberOfValidTransactions() {
			const data = this.$store.getters['user/points'];
			const transactions = data.transactions;

			if (Array.isArray(transactions)) {
				return transactions.filter(transaction => transaction.negative !== -1 && transaction.proj_name !== null).length;
			} else {
				return 0;
			}
		}
	},
	components: {
		VueTypewriter,
		Navigation,
	},

	mounted() {
		document.addEventListener("scroll", this.scrollCheck);
	},
	methods: {
		formUtilsMouseHoverEffect,

		scrollCheck() {
			this.showFixed = "";
			if (window.scrollY > 30) {
				this.showFixed = true;
			}
		},
		menuButtonClicked() {
			this.closeNavigation = this.closeNavigation === true ? false : true;
			this.$emit("menuButtonClicked", this.closeNavigation);
		},
		goto(refName) {
			var element = this.$parent.$refs[refName];
			var top = element.offsetTop;

			window.scrollTo({top: top, left: 0, behavior: "smooth"});
		},
		formatNumber,
		getAvailablePoints
	},
};
</script>
